<template>
  <Stack gap="4">
    <div>
      <Title size="5">Groups</Title>
      <Subtitle>
        View and traverse this person's groups
      </Subtitle>
    </div>

    <template v-if="hasData">
      <!-- Handle both single object and array cases -->
      <template v-if="Array.isArray(treeData)">
        <div v-for="node in treeData" :key="node.entity.external_id" class="tree-node">
          <TreeNode 
            :node="node" 
            :current-entity-id="currentEntityId"
            :show-checkboxes="showCheckboxes"
            @checkbox-toggled="onCheckboxToggled"
          />
        </div>
      </template>

      <template v-else>
        <TreeNode 
          :node="treeData" 
          :current-entity-id="currentEntityId"
          :show-checkboxes="showCheckboxes"
          @checkbox-toggled="onCheckboxToggled"
        />
      </template>
    </template>

    <Callout v-else>
      No relationship data available
    </Callout>
  </Stack>
</template>

<script>
import TreeNode from './TreeNode.vue';
import {
  Callout,
  Stack,
  Subtitle,
  Title,
} from '@stakeui';

export default {
  name: 'EntityTree',
  components: {
    TreeNode,
    Callout,
    Stack,
    Subtitle,
    Title,
  },
  props: {
    treeData: {
      type: [Array, Object],
      default: () => null,
    },
    currentEntityId: {
      type: [String, Number],
      required: true,
    },
    showCheckboxes: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasData() {
      return this.treeData && (
        (Array.isArray(this.treeData) && this.treeData.length > 0) ||
        (this.treeData.entity && this.treeData.descendants)
      );
    },
  },
  methods: {
    onCheckboxToggled({ node, isChecked }) {
      this.$emit('checkbox-toggled', { node, isChecked });
    },
  },
};
</script>
